import { Expose, Type } from "class-transformer";
import { ProductSearchResultDto } from "./product-search-result.dto";

export class ProductSearchResponseDto {
  @Expose()
  @Type(() => ProductSearchResultDto)
  results: ProductSearchResultDto[] = [];
}
